import axios from 'axios';
import { baseUrlApis } from './index';
import qs from 'qs';
import { URL_CWS_API } from './constants';
import { HttpRequest } from './request.utils';

export default class PluginStoreApi extends HttpRequest {
  constructor() {
    super();
    this.CPDFURI = '';
  }
  initialize() {
    try {
      baseUrlApis.getBaseUrlBy(URL_CWS_API).then((data) => {
        this.CPDFURI = data;
        let axiosClient = axios.create({
          baseURL: this.CPDFURI,
        });
        super.initialize(axiosClient, () => {
          this.interceptorsFn();
        });
      });
    } catch (error) {
      throw error;
    }
  }
  doGetPluginCategory = async () => {
    try {
      let url = '/cpdfapi/v1/cloud-plugin/category/list';
      let res = await this.get({
        url,
      });

      return res;
    } catch (error) {
      throw error;
    }
  };
  doGetUserPluginList = async ({ userToken, plugin_name_sort, perPage, currentPage }) => {
    if (!userToken) {
      return;
    }

    try {
      let url = '/cpdfapi/v1/cloud-plugin/user/list?access-token=60ff9e85603d5c7591c5750e';
      let params = {
        'access-token': userToken,
      };

      plugin_name_sort && Object.assign(params, { plugin_name_sort });
      perPage && Object.assign(params, { perPage });
      currentPage && Object.assign(params, { currentPage });

      let res = await this.get({
        url,
        config: {
          params,
        },
      });

      return res;
    } catch (error) {
      throw error;
    }
  };
  doGetPluginStoreList = async ({ category_id, plugin_name, perPage, currentPage }) => {
    try {
      let params = {};
      const url = '/cpdfapi/v1/cloud-plugin/list';

      category_id && Object.assign(params, { category_id });
      plugin_name && Object.assign(params, { plugin_name });
      perPage && Object.assign(params, { perPage });
      currentPage && Object.assign(params, { currentPage });

      let res = await this.get({
        url,
        config: {
          params,
        },
      });

      return res;
    } catch (error) {
      throw error;
    }
  };
  doInstallPlugin = async ({ userToken, plugin_id, status }) => {
    if (!userToken) {
      return;
    }

    try {
      const data = new FormData();
      const params = {
        'access-token': userToken,
      };
      const url = '/cpdfapi/v1/cloud-plugin/user';

      data.append('plugin_id', plugin_id);
      status !== undefined && data.append('status', status);

      const res = await this.post({
        url,
        data,
        config: {
          params,
        },
      });

      return res;
    } catch (error) {
      throw error;
    }
  };
  doModifyUserPlugin = async ({ userToken, plugin_id, status, is_remove }) => {
    if (!userToken) {
      return;
    }

    try {
      const params = {
        'access-token': userToken,
      };
      const data = {
        plugin_id,
      };
      const url = '/cpdfapi/v1/cloud-plugin/user';

      status !== undefined && Object.assign(data, { status });
      is_remove !== undefined && Object.assign(data, { is_remove });

      const res = await this.put({
        url,
        data: qs.stringify(data),
        config: { params },
      });

      return res;
    } catch (error) {
      throw error;
    }
  };
}
